export default "__VITE_ASSET__af7476a5__"